<template>
  <fieldset class="tab tab-05 none-bg">
    <div class="heading-form a-center">
      <span class="number">5/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        ปัจจุบันคุณออมเงิน<span class="br767">ในรูปแบบใดบ้าง</span>
      </h2>
      <p class="desc">(เลือกได้มากกว่า 1 ข้อ)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div
            class="icw-input icw-input-checkbox icon-none icw-input-full c-lifestyle"
          >
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savedeposit"
                class="css-checkbox"
                value="savebank"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savedeposit" class="css-label"
                ><i class="ic ic-bank"></i>เงินฝากธนาคาร</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savemutualfund"
                class="css-checkbox"
                value="fund"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savemutualfund" class="css-label"
                ><i class="ic ic-fund"></i>กองทุนรวม</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savelifeinsurance"
                class="css-checkbox"
                value="insurance"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savelifeinsurance" class="css-label"
                ><i class="ic ic-insurance"></i>กรมธรรม์<br />ประกันชีวิต</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savegovernment"
                class="css-checkbox"
                value="bond"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savegovernment" class="css-label"
                ><i class="ic ic-government-bonds"></i>พันธบัตรรัฐบาล</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savegovernmentbank"
                class="css-checkbox"
                value="govement"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savegovernmentbank" class="css-label"
                ><i class="ic ic-goverment-saving-bank"></i>สลากออมสิน /
                ธ.ก.ส.</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Saverealestate"
                class="css-checkbox"
                value="property"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Saverealestate" class="css-label"
                ><i class="ic ic-real-estate"></i>อสังหาริมทรัพย์</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Saveset"
                class="css-checkbox"
                value="assets"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Saveset" class="css-label"
                ><i class="ic ic-stock-market"></i>ลงทุนในตลาดหลักทรัพย์</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Savegold"
                class="css-checkbox"
                value="gold"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Savegold" class="css-label"
                ><i class="ic ic-gold"></i>ทองคำ</label
              >
            </div>
            <div class="checkbox checkbox-inline">
              <input
                type="checkbox"
                name="Savemoney"
                id="Saveother"
                class="css-checkbox more-save-format"
                value="etc"
                v-model="save_format"
                @change="checkValueChecked($event)"
              />
              <label for="Saveother" class="css-label"
                ><i class="ic ic-other"></i
                >{{
                  save_format_etc.trim() == "" ? "อื่นๆ" : save_format_etc
                }}</label
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-05', 'tab-04')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ6"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a
      href="#popup-save-format"
      class="popup-save-format"
      style="display: none;"
      >click me</a
    >
    <div id="popup-save-format" class="mfp-hide modal-input">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <form class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">การออมเงินรูปแบบอื่นๆ</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <input
                          id="txtSaveMoneyEtc"
                          type="text"
                          name="save_format_etc"
                          placeholder="โปรดระบุ"
                          v-model="save_format_etc"
                        />
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          id="btnSubmitSaveMoneyEtc"
                          type="button"
                          class="btn btn-th"
                          @click="ConfJobText()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

/* jQuery */
import jQuery from "jquery";
/* jQuery */

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";
window.jQuery = window.$ = jQuery;
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

export default {
  name: "QuestionStep2_Q5",
  props: {
    QuestionType: String
  },
  mounted() {
    this.$nextTick(() => {
      $(".popup-save-format").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".more-save-format").click(function() {
        $(".popup-save-format").trigger("click");
      });

      $(".popup-save-format").on("mfpClose", function() {
        if (
          $("*[name=save_format_etc]")
            .val()
            .trim() == ""
        ) {
          $("*[name=Savemoney][value=etc]").prop("checked", false);
        } else {
          $("*[name=Savemoney][value=etc]").prop("checked", true);
        }
      });
    });
  },
  data() {
    return {
      save_format:
        my_storage(this.QuestionType, "save_format") == ""
          ? []
          : my_storage(this.QuestionType, "save_format"),
      save_format_etc: my_storage(this.QuestionType, "save_format_etc")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      if (
        this.save_format_etc.trim() == "" &&
        this.save_format.indexOf("etc") > -1
      ) {
        this.save_format.splice(this.save_format.indexOf("etc"), 1);
      } else if (
        this.save_format_etc.trim() != "" &&
        this.save_format.indexOf("etc") == -1
      ) {
        this.save_format.push("etc");
      }
      if (this.save_format.length > 0) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-05", "tab-06");
      }
    },
    ConfJobText() {
      if (this.save_format_etc.trim() != "") {
        $.magnificPopup.close();
      }
    },
    checkValueChecked(evt) {
      //   if (this.save_format.indexOf('etc') == -1) {
      //     this.save_format_etc = ''
      //   }
    }
  },
  computed: {
    isPass() {
      if (
        this.save_format_etc.trim() == "" &&
        this.save_format.indexOf("etc") > -1
      ) {
        this.save_format.splice(this.save_format.indexOf("etc"), 1);
      } else if (
        this.save_format_etc.trim() != "" &&
        this.save_format.indexOf("etc") == -1
      ) {
        this.save_format.push("etc");
      }
      return this.save_format.length > 0;
    }
  }
};
</script>
